import { createStyles, HelpIcon, Theme, Tooltip, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { Component } from 'react'

const jssStyles = (theme: Theme) =>
  createStyles({
    icon: {
      height: 14,
      color: theme.palette.grey['500'],
    },
  })

type TLeanQuoteOptionHelpIconProps = {
  tooltip: string
} & WithStyles<typeof jssStyles, false>

class LeanQuoteOptionHelpIcon extends Component<TLeanQuoteOptionHelpIconProps> {
  render() {
    return (
      <sup>
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{this.props.tooltip}</span>} placement="top">
          <HelpIcon className={this.props.classes.icon} />
        </Tooltip>
      </sup>
    )
  }
}

export const QuoteOptionHelpIcon = withStyles(jssStyles)(LeanQuoteOptionHelpIcon)
